import React, { useState } from "react";
import {
	Route,
	Routes,
	BrowserRouter
} from "react-router-dom";

import AnalyticsTracker from "../../../shared/utils/AnalyticsTracker";
import Menu from "./Menu";
import Login from "./Login";

const IndiceLetras = React.lazy(() =>  import("para-escribir").then(module => ({ default: module.IndiceLetras })))
const ParaEscribirLetra = React.lazy(() => import("./ParaEscribirLetra"));
const IndiceJuegos = React.lazy(() => import("juegos").then(module => ({ default: module.IndiceJuegos })));
const PantallaConfigPixi = React.lazy(() => import("juegos").then(module => ({ default: module.PantallaConfigPixi })));
const Juego = React.lazy(() => import("./Juego"));

export default function App() {
	const [loguedInUser, setLoguedInUser] = useState(sessionStorage.getItem("userName"))

	const doLogin = function (userName) {
		sessionStorage.setItem("userName",userName)
		setLoguedInUser(userName)
	};

	return (
		<>
			{loguedInUser === null && (
				<Login doLogin={doLogin}/>
			)}
			{loguedInUser !== null && (
				<BrowserRouter>
      				<AnalyticsTracker />
					<Routes>
						<Route path="/" element={<Menu />}>
							<Route path="/escribir">
								<Route index element={<IndiceLetras/>} />
								<Route path=":letra" element={<ParaEscribirLetra/>} />
							</Route>
		
							<Route path="/juegos">
								<Route index element={<IndiceJuegos/>} />
								<Route path="config" element={<PantallaConfigPixi />} />
								<Route path=":juego" element={<Juego/>} />

							</Route> 
		
						</Route>
					</Routes>
				</BrowserRouter>
			)}
		</>
	);
}
